// extracted by mini-css-extract-plugin
export default {"container":"Input_container__TqmKA","tag":"Input_tag__5XltZ","selectedTag":"Input_selectedTag__w77A2","row":"Input_row__Z3f05","key":"Input_key__cPFTW","value":"Input_value__TbLQ2"};